import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TableModule } from 'primeng/table';
import { GlPreview, GlPreviewLine } from '../accounting-lifecycle.model';
import { PageDataPanelComponent } from '../../shared/page-layout/page-data-panel.component';

@Component({
    selector: 'app-accounting-gl-preview-panel',
    standalone: true,
    imports: [CommonModule, TableModule, PageDataPanelComponent],
    template: `
        <app-page-data-panel title="GL Preview" [resultText]="preview?.journalEntryNumber || 'No journal yet'">
            <p-table [value]="lines" responsiveLayout="stack">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Account</th>
                        <th>Name</th>
                        <th>Partner</th>
                        <th>Debit</th>
                        <th>Credit</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-line>
                    <tr>
                        <td>{{ accountLabel(line) }}</td>
                        <td>{{ line.name || '-' }}</td>
                        <td>{{ line.partnerType || '-' }} {{ line.partnerId || '' }}</td>
                        <td>{{ money(line.debit) }}</td>
                        <td>{{ money(line.credit) }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5" class="empty-cell">No journal lines are available.</td>
                    </tr>
                </ng-template>
            </p-table>
        </app-page-data-panel>
    `,
    styles: [`.empty-cell { padding: 1rem; text-align: center; color: #64748b; }`],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountingGlPreviewPanelComponent {
    @Input() preview?: GlPreview;

    get lines(): GlPreviewLine[] {
        return this.preview?.currentLines || [];
    }

    money(amount?: number): string {
        return Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    accountLabel(line: GlPreviewLine): string {
        return [line.accountCode, line.accountName].filter(Boolean).join(' — ') || '-';
    }
}
